import script from "./ip-blocking-ranking-chart.vue?vue&type=script&setup=true&lang=ts"
export * from "./ip-blocking-ranking-chart.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__